/**
 * Apply Cloudinary transformations to reduce image quality and size.
 * - Catalog/list: small, compressed
 * - Detail: medium, moderate quality
 * - Thumbnail: tiny
 */

const TRANSFORMS = {
  catalog: 'q_50,w_600,f_auto',    // Product cards in listings
  detail: 'q_55,w_900,f_auto',     // Product detail main image
  thumb: 'q_40,w_200,f_auto',      // Thumbnails, cart
};

export function optimizeImage(url, preset = 'catalog') {
  if (!url || !url.includes('res.cloudinary.com')) return url;
  const transform = TRANSFORMS[preset] || TRANSFORMS.catalog;
  return url.replace('/upload/', `/upload/${transform}/`);
}
